import { ChangeDetectionStrategy, Component, inject, InjectionToken } from '@angular/core';
import { MatButton } from '@angular/material/button';

export interface ActionNotificationData {
  message: string;
  action: string;
  onAction: () => void;
}

export const ACTION_NOTIFICATION_DATA = new InjectionToken<ActionNotificationData>('ACTION_NOTIFICATION_DATA');

@Component({
  selector: 'rms-action-notification',
  imports: [MatButton],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div
      class="mat-elevation-z6 flex items-center min-w-[min(344px,calc(100vw_-_16px))] max-w-[min(672px,calc(100vw_-_16px))] pr-2 rounded-[var(--mat-snack-bar-container-shape)] bg-[var(--mat-snack-bar-container-color)] text-[var(--mat-snack-bar-supporting-text-color)]"
      role="alert"
      aria-live="assertive">
      <span class="grow py-3.5 pl-4 pr-2">{{ data.message }}</span>
      <button
        mat-button
        type="button"
        (click)="data.onAction()">
        {{ data.action }}
      </button>
    </div>
  `,
})
export class ActionNotificationComponent {
  protected readonly data = inject(ACTION_NOTIFICATION_DATA);
}
